// TODO: Require helpers directly rather than use this file

define('core/extensions/handlebars.helpers',['require','handlebars','./helpers/eq','./helpers/ne','./helpers/gt','./helpers/lt','./helpers/ge','./helpers/le','./helpers/typeof','./helpers/notNull','./helpers/any','./helpers/if_any','./helpers/if_all','./helpers/switch','./helpers/partial','./helpers/getPartial','./helpers/gettext','./helpers/urlfor','./helpers/html','./helpers/with','./helpers/each','./helpers/log','./helpers/debug','./helpers/geturl','./helpers/tag','./helpers/now'],function (require) {  // eslint-disable-line requirejs/no-commonjs-wrapper
    'use strict';

    var Handlebars = require('handlebars');

    // Comparison helpers, for use in subexpressions
    Handlebars.registerHelper('eq', require('./helpers/eq'));
    Handlebars.registerHelper('ne', require('./helpers/ne'));
    Handlebars.registerHelper('gt', require('./helpers/gt'));
    Handlebars.registerHelper('lt', require('./helpers/lt'));
    Handlebars.registerHelper('ge', require('./helpers/ge'));
    Handlebars.registerHelper('le', require('./helpers/le'));
    Handlebars.registerHelper('typeof', require('./helpers/typeof'));
    Handlebars.registerHelper('notNull', require('./helpers/notNull'));

    Handlebars.registerHelper('any', require('./helpers/any'));
    Handlebars.registerHelper('if_any', require('./helpers/if_any'));
    Handlebars.registerHelper('if_all', require('./helpers/if_all'));

    Handlebars.registerHelper('switch', require('./helpers/switch'));

    Handlebars.registerHelper('partial', require('./helpers/partial'));
    Handlebars.registerHelper('getPartial', require('./helpers/getPartial'));
    Handlebars.registerHelper('gettext', require('./helpers/gettext'));
    Handlebars.registerHelper('urlfor', require('./helpers/urlfor'));
    Handlebars.registerHelper('html', require('./helpers/html'));
    Handlebars.registerHelper('with', require('./helpers/with'));
    Handlebars.registerHelper('each', require('./helpers/each'));

    // development-only helpers
    Handlebars.registerHelper('log', require('./helpers/log'));
    Handlebars.registerHelper('debug', require('./helpers/debug'));
    Handlebars.registerHelper('geturl', require('./helpers/geturl'));

    Handlebars.registerHelper('tag', require('./helpers/tag'));
    Handlebars.registerHelper('now', require('./helpers/now'));

    return Handlebars;
});

